import styled from "styled-components";

export const ChartsContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
`;

export const ChartWrapper = styled.div``;
